import type { Actions } from '@atlaskit/onboarding/types';

type Action = Actions[number] & { ctaType?: 'primary' | 'secondary'; href?: string };
type TranslatedAction = Omit<Action, 'appearance'>;
type CTAs = { primary?: TranslatedAction; secondary?: TranslatedAction };

const sanitizeAction = (action: Action | undefined): TranslatedAction | undefined => {
	if (action === undefined) {
		return undefined;
	}

	const { appearance: _ignoredAppearance, ...remainingActionProps } = action;

	return remainingActionProps;
};

export const actionsTranslation = (value?: Action[]): CTAs => {
	if (!value || value.length === 0) {
		return {};
	}

	if (value.length === 1) {
		const [primary] = value;
		return {
			primary: sanitizeAction(primary),
		};
	}

	const primary = value.find((action) => action.ctaType === 'primary');
	const secondary = value.find((action) => action.ctaType === 'secondary');

	if (primary && secondary) {
		return {
			primary: sanitizeAction(primary),
			secondary: sanitizeAction(secondary),
		};
	}

	if (primary) {
		// Only primary found, assign the other as secondary
		const other = value.find((action) => action !== primary);
		return {
			primary: sanitizeAction(primary),
			secondary: sanitizeAction(other),
		};
	}

	if (secondary) {
		// Only secondary found, assign the other as primary
		const other = value.find((action) => action !== secondary);
		return {
			primary: sanitizeAction(other),
			secondary: sanitizeAction(secondary),
		};
	}

	// Neither ctaType is set, assume second is primary, first is secondary
	const [secondaryFallback, primaryFallback] = value;
	return {
		primary: sanitizeAction(primaryFallback),
		secondary: sanitizeAction(secondaryFallback),
	};
};
